import { AlertBox } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './TrueLayerLinkedAccount.module.css';
import { TOnlineBank } from '../OpenBanking.types';

type TProps = {
  linkedBankAccount?: TOnlineBank;
};

const TrueLayerLinkedAccount = ({ linkedBankAccount }: TProps) => {
  if (!linkedBankAccount) return null;

  const linkedBankName = linkedBankAccount.bank_name;

  return (
    <AlertBox className={styles.bankAccountStatus} variant="connect">
      <img
        className={styles.trueLayerBankLogo}
        src={linkedBankAccount.logo_url}
        alt={linkedBankAccount.bank_name}
      />
      <strong>
        <Trans>Your {linkedBankName} account is now linked.</Trans>
      </strong>
    </AlertBox>
  );
};

export default TrueLayerLinkedAccount;
